import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR, formatDateBR } from "../../../../../helpers/format";
import { IValidacaoCRLV } from "../Create/types/types";

// import { Container } from './styles';

interface Props {
  data?: IValidacaoCRLV;
  title: string;
  onClose: () => void;
  states: any[];
}

const Info: React.FC<Props> = (props: Props) => {

  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_configuracao_crlv || props.data?.id_validacao_crlv || props.data?.id || '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Estado
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data && props.data.id_estado ? props.states.find(s => s.id_estado === props.data?.id_estado)?.nome || props.data.id_estado : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Ano de Exercício
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.ano_exercicio ? props.data.ano_exercicio : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Final da Placa
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.final_placa ? props.data.final_placa : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Validade do Exercício
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.validade_exercicio ? formatDateBR(props.data.validade_exercicio) : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Número da Portaria
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.numero_portaria ? props.data.numero_portaria : '---'}
            </span>
          </div>
        </div>
        <div className="w-full grid grid-cols-1 gap-2 gap-y-6 mt-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Usuário
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ? props.data.usuario : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data Modificação
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_historico ? formatDateTimeBR(props.data.data_historico) : '---'}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
